import axios from 'axios';

const API_ENTRY = '/api/v1';

class API {
  static entry  = API_ENTRY;
  static signUp = '/submitters';
  static logIn  =  '/oauth/token';
  static updatePwd = '/api/v1/password';
  static postData = '/indications';

  static auth_cfg = token => ({    
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  static crsf_cfg = () => { 
  return {
    headers: {
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content")
    },
    withCredentials: true,
  }}

  static req = async ( url, method, data, cfg = {} ) => {
    console.log( 'Api.req ',cfg)
    const axcfg = {
      ...cfg,
      method: method,
      baseURL: '/',
      url,
      data
    }
    return axios( axcfg )
    .catch( (error) => {
      let message = '';
      if (error.response) {
        // Request made and server responded
        if (error.response.data && error.response.data.message) {
          message = error.response.data.message;
          console.log(error.response.data);
        }
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        message = error.message
        console.log('Error', error.message);
      }  
      const err = new Error( message || 'Authentication failed' );
      console.log(err.name + ': ' + err.message);
      throw err;
    }) // catch error
    .then( (res) => {
      console.log( res );
      // res.data.access_token
      // res.data.expires_in
      // res.data.refresh_token
      if (res.status === 200 ) {
        //if (isLogin) {
          console.log( '[axios] ', res, res.data)
          return res.data;
        //} else {
        //  console.log( '[result]', res );
        //  window.alert( res.data.message );
        //  navigate('/submit/'); 
        //}

      } else {
        return res
        // .then((data) => {
        //   let errorMessage = 'Authentication failed!';
        //   if (data && data.error && data.error.message) {
        //      errorMessage = data.error.message;
        //   }

        //   throw new Error(errorMessage);
        // });
      }
    })

  }
}

export default API;